import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getBlogPost, type BlogPost } from "../services/bloggerApi";

const SingleBlogPost = () => {
  const { postId } = useParams<{ postId: string }>();
  const [post, setPost] = useState<BlogPost | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPost = async () => {
      if (!postId) return;

      try {
        setLoading(true);
        const postData = await getBlogPost(postId);
        setPost(postData);
        setError(null);
      } catch (err) {
        setError("Blog yazısı yüklenirken bir hata oluştu.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [postId]);

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        </div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
          <p>{error || "Blog yazısı bulunamadı."}</p>
          <Link
            to="/"
            className="text-blue-600 hover:underline mt-2 inline-block"
          >
            Ana Sayfaya Dön
          </Link>
        </div>
      </div>
    );
  }

  const formattedDate = new Date(post.published).toLocaleDateString("tr-TR", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="container mx-auto px-4 py-32 max-w-4xl">
      <Link
        to="/etkinliklerimiz"
        className="text-blue-600 hover:underline mb-6 inline-block"
      >
        &larr; Etkinliklere Dön
      </Link>

      <article className="bg-white rounded-xl shadow-md overflow-hidden">
        {post.images && post.images.length > 0 && (
          <div className="relative h-64 md:h-80 overflow-hidden">
            <img
              src={post.images[0]}
              alt={post.title}
              className="w-full h-full object-cover"
            />
          </div>
        )}

        <div className="p-4 md:p-8">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            {post.title}
          </h1>

          <div className="flex items-center gap-4 mb-6">
            {post.author.image?.url ? (
              <img
                src={post.author.image.url}
                alt={post.author.displayName}
                className="w-10 h-10 md:w-12 md:h-12 rounded-full"
              />
            ) : (
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gray-200" />
            )}
            <div>
              <p className="text-sm font-medium text-gray-900">
                {post.author.displayName}
              </p>
              <p className="text-sm text-gray-500">{formattedDate}</p>
            </div>
          </div>

          <div
            className="prose max-w-none"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />

          {post.images && post.images.length > 1 && (
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {post.images.slice(1).map((image, index) => (
                <div key={index} className="overflow-hidden rounded-lg">
                  <img
                    src={image}
                    alt={`${post.title} - Görsel ${index + 2}`}
                    className="w-full h-40 md:h-48 object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </article>
    </div>
  );
};

export default SingleBlogPost;
